'use strict';
import * as $j_app$002eauth$002e$002dOperational$002dUser$002dWith$002dClient$0024$002dGeneral$002dPractice from "./app.auth.-Operational-User-With-Client$-General-Practice.js";
import * as $j_app$002edata$002e$002dApp$002dAuth$002dData$0024 from "./app.data.-App-Auth-Data$.js";
import * as $j_app$002edata$002e$002dApp$002dAuth$002dData$0024$002dGeneral$002dPractice$002dUser$0024$002dImpersonating from "./app.data.-App-Auth-Data$-General-Practice-User$-Impersonating.js";
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_auth_OperationalUserWithClient$GeneralPractice$Impersonating(admin, gpUserId, server) {
  this.Lapp_auth_OperationalUserWithClient$GeneralPractice$Impersonating__f_outOfOfficeSignal$lzy2 = null;
  this.Lapp_auth_OperationalUserWithClient$GeneralPractice$Impersonating__f_outOfOfficeSignalbitmap$2 = false;
  this.Lapp_auth_OperationalUserWithClient$GeneralPractice$Impersonating__f_isOutOfOfficeSignal$lzy2 = null;
  this.Lapp_auth_OperationalUserWithClient$GeneralPractice$Impersonating__f_isOutOfOfficeSignalbitmap$2 = false;
  this.Lapp_auth_OperationalUserWithClient$GeneralPractice$Impersonating__f_admin = null;
  this.Lapp_auth_OperationalUserWithClient$GeneralPractice$Impersonating__f_gpUserId = null;
  this.Lapp_auth_OperationalUserWithClient$GeneralPractice$Impersonating__f_server = null;
  this.Lapp_auth_OperationalUserWithClient$GeneralPractice$Impersonating__f_admin = admin;
  this.Lapp_auth_OperationalUserWithClient$GeneralPractice$Impersonating__f_gpUserId = gpUserId;
  this.Lapp_auth_OperationalUserWithClient$GeneralPractice$Impersonating__f_server = server;
}
export { $c_Lapp_auth_OperationalUserWithClient$GeneralPractice$Impersonating as $c_Lapp_auth_OperationalUserWithClient$GeneralPractice$Impersonating };
$c_Lapp_auth_OperationalUserWithClient$GeneralPractice$Impersonating.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_auth_OperationalUserWithClient$GeneralPractice$Impersonating.prototype.constructor = $c_Lapp_auth_OperationalUserWithClient$GeneralPractice$Impersonating;
/** @constructor */
function $h_Lapp_auth_OperationalUserWithClient$GeneralPractice$Impersonating() {
}
export { $h_Lapp_auth_OperationalUserWithClient$GeneralPractice$Impersonating as $h_Lapp_auth_OperationalUserWithClient$GeneralPractice$Impersonating };
$h_Lapp_auth_OperationalUserWithClient$GeneralPractice$Impersonating.prototype = $c_Lapp_auth_OperationalUserWithClient$GeneralPractice$Impersonating.prototype;
$c_Lapp_auth_OperationalUserWithClient$GeneralPractice$Impersonating.prototype.outOfOfficeSignal__Lcom_raquo_airstream_core_Signal = (function() {
  if ((!this.Lapp_auth_OperationalUserWithClient$GeneralPractice$Impersonating__f_outOfOfficeSignalbitmap$2)) {
    this.Lapp_auth_OperationalUserWithClient$GeneralPractice$Impersonating__f_outOfOfficeSignal$lzy2 = $j_app$002eauth$002e$002dOperational$002dUser$002dWith$002dClient$0024$002dGeneral$002dPractice.$f_Lapp_auth_OperationalUserWithClient$GeneralPractice__outOfOfficeSignal__Lcom_raquo_airstream_core_Signal(this);
    this.Lapp_auth_OperationalUserWithClient$GeneralPractice$Impersonating__f_outOfOfficeSignalbitmap$2 = true;
  }
  return this.Lapp_auth_OperationalUserWithClient$GeneralPractice$Impersonating__f_outOfOfficeSignal$lzy2;
});
$c_Lapp_auth_OperationalUserWithClient$GeneralPractice$Impersonating.prototype.isOutOfOfficeSignal__Lcom_raquo_airstream_core_Signal = (function() {
  if ((!this.Lapp_auth_OperationalUserWithClient$GeneralPractice$Impersonating__f_isOutOfOfficeSignalbitmap$2)) {
    this.Lapp_auth_OperationalUserWithClient$GeneralPractice$Impersonating__f_isOutOfOfficeSignal$lzy2 = $j_app$002eauth$002e$002dOperational$002dUser$002dWith$002dClient$0024$002dGeneral$002dPractice.$f_Lapp_auth_OperationalUserWithClient$GeneralPractice__isOutOfOfficeSignal__Lcom_raquo_airstream_core_Signal(this);
    this.Lapp_auth_OperationalUserWithClient$GeneralPractice$Impersonating__f_isOutOfOfficeSignalbitmap$2 = true;
  }
  return this.Lapp_auth_OperationalUserWithClient$GeneralPractice$Impersonating__f_isOutOfOfficeSignal$lzy2;
});
$c_Lapp_auth_OperationalUserWithClient$GeneralPractice$Impersonating.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lapp_auth_OperationalUserWithClient$GeneralPractice$Impersonating.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, 1902162089, true);
});
$c_Lapp_auth_OperationalUserWithClient$GeneralPractice$Impersonating.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lapp_auth_OperationalUserWithClient$GeneralPractice$Impersonating)) {
    var x = this.Lapp_auth_OperationalUserWithClient$GeneralPractice$Impersonating__f_admin;
    var x$2 = x$0.Lapp_auth_OperationalUserWithClient$GeneralPractice$Impersonating__f_admin;
    if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
      var x$3 = this.Lapp_auth_OperationalUserWithClient$GeneralPractice$Impersonating__f_gpUserId;
      var x$4 = x$0.Lapp_auth_OperationalUserWithClient$GeneralPractice$Impersonating__f_gpUserId;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$5 = this.Lapp_auth_OperationalUserWithClient$GeneralPractice$Impersonating__f_server;
      var x$6 = x$0.Lapp_auth_OperationalUserWithClient$GeneralPractice$Impersonating__f_server;
      return ((x$5 === null) ? (x$6 === null) : x$5.equals__O__Z(x$6));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lapp_auth_OperationalUserWithClient$GeneralPractice$Impersonating.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lapp_auth_OperationalUserWithClient$GeneralPractice$Impersonating.prototype.productArity__I = (function() {
  return 3;
});
$c_Lapp_auth_OperationalUserWithClient$GeneralPractice$Impersonating.prototype.productPrefix__T = (function() {
  return "Impersonating";
});
$c_Lapp_auth_OperationalUserWithClient$GeneralPractice$Impersonating.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Lapp_auth_OperationalUserWithClient$GeneralPractice$Impersonating__f_admin;
      break;
    }
    case 1: {
      return this.Lapp_auth_OperationalUserWithClient$GeneralPractice$Impersonating__f_gpUserId;
      break;
    }
    case 2: {
      return this.Lapp_auth_OperationalUserWithClient$GeneralPractice$Impersonating__f_server;
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lapp_auth_OperationalUserWithClient$GeneralPractice$Impersonating.prototype.productElementName__I__T = (function(n) {
  switch (n) {
    case 0: {
      return "admin";
      break;
    }
    case 1: {
      return "gpUserId";
      break;
    }
    case 2: {
      return "server";
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lapp_auth_OperationalUserWithClient$GeneralPractice$Impersonating.prototype.server__Lapp_data_OperationalAppRegisteredUser$GeneralPractice = (function() {
  return this.Lapp_auth_OperationalUserWithClient$GeneralPractice$Impersonating__f_server;
});
$c_Lapp_auth_OperationalUserWithClient$GeneralPractice$Impersonating.prototype.authData__Lcom_raquo_airstream_core_Signal = (function() {
  $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_airstream_core_Observable$();
  var observable = this.Lapp_auth_OperationalUserWithClient$GeneralPractice$Impersonating__f_admin.authData__Lcom_raquo_airstream_core_Signal();
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_airstream_extensions_OptionObservable$().mapSome$extension__Lcom_raquo_airstream_core_BaseObservable__F1__Lcom_raquo_airstream_core_Observable(observable, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((adminAuth) => {
    var userId = this.Lapp_auth_OperationalUserWithClient$GeneralPractice$Impersonating__f_gpUserId;
    return new $j_app$002edata$002e$002dApp$002dAuth$002dData$0024$002dGeneral$002dPractice$002dUser$0024$002dImpersonating.$c_Lapp_data_AppAuthData$GeneralPracticeUser$Impersonating(adminAuth, userId);
  })));
});
$c_Lapp_auth_OperationalUserWithClient$GeneralPractice$Impersonating.prototype.authDataCodec__Lsttp_tapir_Codec = (function() {
  return $j_app$002edata$002e$002dApp$002dAuth$002dData$0024.$m_Lapp_data_AppAuthData$().gpCodec__Lsttp_tapir_Codec();
});
$c_Lapp_auth_OperationalUserWithClient$GeneralPractice$Impersonating.prototype.server__Lapp_data_OperationalAppRegisteredUser = (function() {
  return this.Lapp_auth_OperationalUserWithClient$GeneralPractice$Impersonating__f_server;
});
function $isArrayOf_Lapp_auth_OperationalUserWithClient$GeneralPractice$Impersonating(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lapp_auth_OperationalUserWithClient$GeneralPractice$Impersonating)));
}
export { $isArrayOf_Lapp_auth_OperationalUserWithClient$GeneralPractice$Impersonating as $isArrayOf_Lapp_auth_OperationalUserWithClient$GeneralPractice$Impersonating };
var $d_Lapp_auth_OperationalUserWithClient$GeneralPractice$Impersonating = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_auth_OperationalUserWithClient$GeneralPractice$Impersonating, "app.auth.OperationalUserWithClient$GeneralPractice$Impersonating", ({
  Lapp_auth_OperationalUserWithClient$GeneralPractice$Impersonating: 1,
  Lapp_auth_HasAuthData: 1,
  Lapp_auth_OperationalUserWithClient: 1,
  Lapp_auth_OperationalUserWithClient$GeneralPractice: 1,
  Lapp_auth_OperationalUserWithClient$Impersonating: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lapp_auth_OperationalUserWithClient$GeneralPractice$Impersonating as $d_Lapp_auth_OperationalUserWithClient$GeneralPractice$Impersonating };
//# sourceMappingURL=app.auth.-Operational-User-With-Client$-General-Practice$-Impersonating.js.map
